module.exports = __webpack_public_path__ + "img/check-circle-border-green.e0a91c90.svg";